import type { RootState, AppDispatch } from "@store";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
const useAppDispatch: () => AppDispatch = useDispatch;
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { useAppDispatch, useAppSelector };

export { default as useApi } from "./useApi";
export { default as useCurrentUser } from "./useCurrentUser";
export { default as useResponsive } from "./useResponsive";
export { default as useToast } from "./useToast";
